import { styled } from '@mui/system';

type TextAreaWrapperProps = {
  'data-content': string;
  $initialHeight: string;
  $paddingY?: string;
  $borderRadius?: string;
  $grayInput?: boolean;
};
export const FieldWrapper = styled('div')``;

export const Label = styled('label')<{
  $content: string;
  $insetY?: string;
}>`
  position: absolute;
  left: 1.5rem;
  top: ${({ $insetY }) => $insetY || '1.5rem'};
  opacity: ${({ $content }) => ($content ? 0 : 1)};
  color: #aeadad;
  transition: opacity 0.2s ease;
  cursor: text;
`;

export const Field = styled('textarea')<{ $fontSize?: string }>`
  resize: none;
  overflow: hidden;
  transition: color 0.2s ease;
  font-size: ${({ $fontSize }) => $fontSize || '1.125rem'} !important;
  line-height: 1.5rem;
  background-color: #ffffff;
  outline: none;
  border-width: 1px;
  border-style: solid;
  border-color: #f3f4f8;
  &:focus,
  &:focus-visible {
    outline: none;
    border-color: #5fa3a9;
  }
  &:focus ~ ${Label}, &:focus-visible ~ ${Label} {
    opacity: 0;
  }
`;

export const TextAreaWrapper = styled('div')<TextAreaWrapperProps>`
  display: grid;
  position: relative;
  background-color: transparent;
  &::after {
    content: attr(data-content) '';
    white-space: pre-wrap;
    word-break: break-word;
    visibility: hidden;
    background-color: transparent;
  }
  &::after,
  ${Field} {
    box-sizing: border-box;
    padding: ${({ $paddingY }) => $paddingY || '1.5rem'} 1.25rem;
    font: inherit;
    grid-area: 1 / 1 / 2 / 2;
    border-radius: ${({ $borderRadius }) => $borderRadius || '1rem'};
    min-height: ${({ $initialHeight }) => $initialHeight};
    ${({ $grayInput, theme }) =>
      $grayInput ? `background-color: ${theme.palette.grey[100]}` : ''}
  }
`;
